import './layout.pcss';
import angular from 'angular';
import 'angular-i18n/angular-locale_hu-hu';
import '../../common/common';
import '../../application/office-and-advisor-search-page-handler/office-and-advisor-search-page-handler.module';

const MODULE_NAME = 'AIRTA-app';

export default angular.module(MODULE_NAME, window.dependencies).name;


